import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { map } from 'rxjs/operators';

import { PageDto } from './../shared/page.dto';
import { PageQueriesModel } from './../shared/page-queries.model';
import { ContractDto } from './contract.dto';

@Injectable()
export class ContractsRestService {
  constructor(private http: HttpClient) {}

  list(queries: PageQueriesModel, legalentityId: string, clientId: string) {
    const url = this.apiUrl(legalentityId, clientId);
    const options = {
      params: queries.getParams()
    };

    return this.http.get<PageDto<ContractDto>>(url, options).pipe(
      map(d => {
        const page = new PageDto(d);
        page.content = d.content.map(i => new ContractDto(i));
        return page;
      })
    );
  }

  create(d: ContractDto, legalentityId: string, clientId: string) {
    const url = this.apiUrl(legalentityId, clientId);
    return this.http
      .post<ContractDto>(url, d)
      .pipe(map(data => new ContractDto(data)));
  }

  get(contractId: string) {
    const url = `api/contractManagement/contracts/${contractId}`;

    return this.http.get<ContractDto>(url).pipe(map(d => new ContractDto(d)));
  }

  remove(clientId: string, legalentityId: string, contractId: string) {
    const url = this.apiUrlByContract(contractId, legalentityId, clientId);

    return this.http
      .delete<ContractDto>(url)
      .pipe(map(d => new ContractDto(d)));
  }

  update(d: ContractDto, legalentityId: string, clientId: string) {
    const url = this.apiUrlByContract(d.identity.id, legalentityId, clientId);
    return this.http
      .put<ContractDto>(url, d)
      .pipe(map(data => new ContractDto(data)));
  }

  clone(d: ContractDto, legalentityId: string, clientId: string) {
    const url = this.apiUrlCloneContract(
      d.identity.id,
      legalentityId,
      clientId
    );
    return this.http
      .post<ContractDto>(url, d)
      .pipe(map(data => new ContractDto(data)));
  }

  private apiUrlCloneContract(
    contractId: string,
    legalentityId: string,
    clientId: string
  ) {
    return `api/contractManagement/clients/${clientId}/legalentities/${legalentityId}/contracts/${contractId}/clone`;
  }

  private apiUrlByContract(
    contractId: string,
    legalentityId: string,
    clientId: string
  ) {
    return `api/contractManagement/clients/${clientId}/legalentities/${legalentityId}/contracts/${contractId}`;
  }

  private apiUrl(legalentityId: string, clientId: string) {
    return `api/contractManagement/clients/${clientId}/legalentities/${legalentityId}/contracts`;
  }
}
